const palette = {
	primary: { main: '#4f38a7' },
	secondary: { main: '#4f38a7' },
};

export default palette;
